import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SantriPage from "@/pages/SantriPage";
import KelasPage from "@/pages/KelasPage";
import UstadzPage from "@/pages/UstadzPage";
import PenggunaPage from "@/pages/PenggunaPage";
import KitabPage from "@/pages/KitabPage";
import PembayaranPage from "@/pages/PembayaranPage";
import LaporanPage from "@/pages/LaporanPage";
import AbsensiSantriPage from "@/pages/AbsensiSantriPage";
import AbsensiUstadzPage from "@/pages/AbsensiUstadzPage";
import RekapAbsensiPage from "@/pages/RekapAbsensiPage";
import TahunAjaranPage from "@/pages/TahunAjaranPage";
import MataPelajaranPage from "@/pages/MataPelajaranPage";
import JenisUjianPage from "@/pages/JenisUjianPage";
import InputNilaiPage from "@/pages/InputNilaiPage";
import RekapNilaiPage from "@/pages/RekapNilaiPage";
import PeringkatKelasPage from "@/pages/PeringkatKelasPage";
import KenaikanKelasPage from "@/pages/KenaikanKelasPage";
import ImportExportPage from "@/pages/ImportExportPage";
import AssignmentsPage from "@/pages/AssignmentsPage";
import JadwalPage from "@/pages/JadwalPage";
import ProgressPenilaianPage from "@/pages/ProgressPenilaianPage";
import CatatanWaliPage from "@/pages/CatatanWaliPage";
import AuditLogPage from "@/pages/AuditLogPage";
import SettingsPage from "@/pages/SettingsPage";
import BackupPage from "@/pages/BackupPage";
import NativeBridge from "@/components/NativeBridge";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <NativeBridge />
        <InstallPrompt />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/santri" element={<SantriPage />} />
            <Route path="/kelas" element={<KelasPage />} />
            <Route
              path="/ustadz"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <UstadzPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kitab"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <KitabPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pembayaran"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <PembayaranPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/laporan"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <LaporanPage />
                </ProtectedRoute>
              }
            />
            <Route path="/absensi/santri" element={<AbsensiSantriPage />} />
            <Route
              path="/absensi/ustadz"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <AbsensiUstadzPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/absensi/rekap"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <RekapAbsensiPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tahun-ajaran"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <TahunAjaranPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kenaikan-kelas"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <KenaikanKelasPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import-export"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <ImportExportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mata-pelajaran"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <MataPelajaranPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jenis-ujian"
              element={
                <ProtectedRoute roles={["admin", "sekretaris"]}>
                  <JenisUjianPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nilai/input"
              element={
                <ProtectedRoute roles={["admin", "ustadz"]}>
                  <InputNilaiPage />
                </ProtectedRoute>
              }
            />
            <Route path="/nilai/rekap" element={<RekapNilaiPage />} />
            <Route path="/nilai/peringkat" element={<PeringkatKelasPage />} />
            <Route path="/nilai/progress" element={<ProgressPenilaianPage />} />
            <Route path="/catatan-wali" element={<CatatanWaliPage />} />
            <Route path="/jadwal" element={<JadwalPage />} />
            <Route
              path="/assignments"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AssignmentsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit-log"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AuditLogPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pengaturan"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/backup"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <BackupPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pengguna"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <PenggunaPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
